import React from 'react'
import { Auth } from 'aws-amplify'
import { Image, Dropdown } from 'react-bootstrap'

import * as AppDefinitions from '../../App.d'
import * as I from '../../utilities/me'
import * as ApiDefinitions from '../../../../back-end/utilities/apiDefinitions'

import { Dialog } from '../ui/dialog/dialog'

interface UserButtonProps {
	userAttributes: AppDefinitions.CognitoUserAttributes
	permission: AppDefinitions.Permission
	accounts: ApiDefinitions.Account[]
	selectedOrg?: ApiDefinitions.AccountXeroOrg
}

const refreshSession = async () => {
	const session = await Auth.currentSession()
	const user = await Auth.currentAuthenticatedUser()
	return new Promise((resolve, reject) => {
		user.refreshSession(session.getRefreshToken(), (err: unknown, session: unknown) => {
			if (err) {
				reject(err)
			} else {
				resolve(session)
			}
		})
	})
}

export const UserButton = (props: UserButtonProps) => {
	const [showDialog, updateShowDialog] = React.useState<boolean>(false)
	const signOut = () => {
		Auth.signOut()
			.then(() => {
				window.location.href = '/'
			})
			.catch((err: Error) => console.log(err))
	}

	const onAccountSwitch = async (eventKey: string, accounts?: ApiDefinitions.Account[]) => {
		updateShowDialog(false)

		const accountID = eventKey
		const selectedAccount = accounts ? accounts[0] : props.accounts.find((account) => account.accountID === accountID)
		await Auth.currentAuthenticatedUser()

		if (selectedAccount) {
			const user = await Auth.currentAuthenticatedUser()

			await Auth.updateUserAttributes(user, {
				'custom:currentAccountId': accountID,
				'custom:userAccountId': selectedAccount.userAccountID,
				'custom:role': JSON.stringify({
					os: selectedAccount.osPermissionID,
					lc: selectedAccount.lcPermissionID,
					tayg: selectedAccount.taygPermissionID,
				}),
			})
			await refreshSession()

			window.location.href = '/'
			window.location.reload()
		}
	}

	return (
		<Dropdown>
			<Dropdown.Toggle className="no-caret" variant="secondary" id="userprofile">
				<Image
					src={`https://ui-avatars.com/api/?name=${props.userAttributes.given_name}+${props.userAttributes.family_name}&background=cdf3ff`}
					roundedCircle
					className="avatar"
				/>
			</Dropdown.Toggle>
			<Dropdown.Menu>
				<Dropdown.Item href={'/'} disabled={!props.permission || props.accounts.length === 0}>
					Home
				</Dropdown.Item>
				{I.haveAtLeast('director', props.permission.roleID) && (
					<Dropdown.Item href={`/accountSettings`} disabled={!props.permission || props.accounts.length === 0}>
						Account Settings
					</Dropdown.Item>
				)}
				<Dropdown.Item href="https://help.finlert.com/xpm-to-xero-wip-invoice-mngr/" target="_blank">
					Help
				</Dropdown.Item>
				{I.have('admin', props.permission.roleID) ? (
					<>
						<Dropdown.Item href={`/xero/connections`}>Xero Connections</Dropdown.Item>
					</>
				) : null}
				{props.accounts.length > 1 ? (
					<>
						<Dropdown.Item onClick={() => updateShowDialog(true)}>Switch Account</Dropdown.Item>
					</>
				) : null}
				<Dropdown.Divider />
				<Dropdown.Item onClick={signOut}>Log out</Dropdown.Item>
				<Dialog
					show={showDialog}
					handleClose={() => updateShowDialog(false)}
					titleText={'Which account do you want to log into?'}
					elements={props.accounts}
					currentElem={props.selectedOrg ? props.selectedOrg!.account!.accountID : props.userAttributes['custom:currentAccountId']}
					handleLogIn={(eventKey) => onAccountSwitch(eventKey)}
				/>
			</Dropdown.Menu>
		</Dropdown>
	)
}
